import script from "./UserActivityControl.vue?vue&type=script&setup=true&lang=js"
export * from "./UserActivityControl.vue?vue&type=script&setup=true&lang=js"

import "./UserActivityControl.vue?vue&type=style&index=0&id=3a738d2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a738d2e"]])

export default __exports__